import { request } from "./http";

export interface Drawdown {
  depth_pct: number;
  duration: number;
  start_index: number;
  end_index: number;
}

export interface TearsheetMetrics {
  total_return_pct: number;
  annualized_return_pct: number;
  sharpe_ratio: number;
  sortino_ratio: number;
  calmar_ratio: number;
  max_drawdown_pct: number;
  max_drawdown_duration_bars: number;
  win_rate: number;
  profit_factor: number;
  payoff_ratio: number;
  total_trades: number;
  avg_win: number;
  avg_loss: number;
}

export interface TearsheetResponse {
  metrics: TearsheetMetrics;
  equity_curve: number[];
  monthly_returns: Record<string, number>;
  rolling_sharpe: number[];
  drawdowns: Drawdown[];
}

export const tearsheet = {
  load: (robotId?: string) =>
    request<TearsheetResponse>(
      robotId
        ? `/piggy/api/tearsheet?robot_id=${encodeURIComponent(robotId)}`
        : "/piggy/api/tearsheet",
    ),
};
